"use client";
import { useFieldContext } from "./use-field-context.js";
//#region src/components/field/field-context.tsx
var FieldContext = (props) => props.children(useFieldContext());
//#endregion
export { FieldContext };
